export var ReferralStatus;
(function (ReferralStatus) {
    ReferralStatus["Pending"] = "pending";
    ReferralStatus["Approved"] = "approved";
    ReferralStatus["Rewarded"] = "rewarded";
    ReferralStatus["Rejected"] = "rejected";
    ReferralStatus["ClawedBack"] = "clawed_back";
})(ReferralStatus || (ReferralStatus = {}));
export var ReferralRejectionReason;
(function (ReferralRejectionReason) {
    ReferralRejectionReason["InvalidCode"] = "invalid_code";
    ReferralRejectionReason["SelfReferral"] = "self_referral";
    ReferralRejectionReason["ProgramDisabled"] = "program_disabled";
    ReferralRejectionReason["CapReached"] = "cap_reached";
    ReferralRejectionReason["ClawedBack"] = "clawed_back";
})(ReferralRejectionReason || (ReferralRejectionReason = {}));
//# sourceMappingURL=referral-status.const.js.map